/** Icônes au trait de la maquette /msc (`PUNCH_UI.P`, viewBox 24, trait 1,8). Décoratives : aria-hidden. */
const PATHS = {
  check: 'M20 6 9 17l-5-5',
  right: 'm9 18 6-6-6-6',
  left: 'm15 18-6-6 6-6',
  clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM12 6.5V12l3.5 2',
  pin: 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0ZM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  // `pin` descendu de 0,6 (0,5 px en 20 px, un pixel physique en ×2) : pastille ronde de la ligne du studio
  // (confirmation). Tête lourde, pointe fine : boîte d'encre centrée, le repère paraissait 0,9 px trop haut
  // (barycentre) ; ici boîte à +0,25 px (comme « en boucle »), barycentre à -0,4 px (relecture du 09/10).
  pinBadge: 'M20 10.6c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0ZM12 13.1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  users:
    'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM12 16.5V11M12 7.6v.1',
  alert: 'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0ZM12 9v4.5M12 17.2v.1',
  cal: 'M4 5h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1ZM3 10h18M8 3v4M16 3v4',
  hourglass: 'M6 2h12M6 22h12M6 2c0 5 6 6 6 10S6 17 6 22M18 2c0 5-6 6-6 10s6 5 6 10',
  // Étoile descendue de 0,5 : encre centrée dans le carré de 24 (y 2,5 → 21,5), centrée sur le texte voisin.
  star: 'm12 2.5 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 18.3 5.8 21.5l1.2-6.9-5-4.9 6.9-1L12 2.5Z',
  lock: 'M5 11h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1ZM8 11V7a4 4 0 0 1 8 0v4',
  // Deux flèches en boucle : « le même cours la semaine prochaine » (confirmation).
  repeat: 'm17 2 4 4-4 4M3 11v-1a4 4 0 0 1 4-4h14M7 22l-4-4 4-4M21 13v1a4 4 0 0 1-4 4H3',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 17, stroke = 1.8 }: { name: IconName; size?: number; stroke?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
